import React from "react";
import "./loading.scss";

export default function Loading() {
  return (
    <div className="loading-bar-container">
      <div className="loading-bar" />
    </div>
  );
}
